import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeFacade } from '../../../facades/home.facade';

/** "Descubre más Propiedades": carrusel de últimas propiedades. Presentacional. */
@Component({
    selector: 'app-section-property',
    templateUrl: './section-property.component.html',
    styleUrls: ['./section-property.component.scss'],
})
export class SectionPropertyComponent implements OnInit {
    responsiveOptions = [
        { breakpoint: '1024px', numVisible: 3, numScroll: 1 },
        { breakpoint: '768px', numVisible: 1, numScroll: 1 },
    ];

    constructor(readonly home: HomeFacade, private readonly router: Router) {}

    ngOnInit(): void {
        this.home.loadLatest();
    }

    openProperty(propertyId: number): void {
        this.router.navigate(['/property', propertyId]);
    }
}
